// @ts-nocheck
import PinFull from "@store/Library/Components/Toolkit/Icons/Pin/PinFull";
import PinLine from "@store/Library/Components/Toolkit/Icons/Pin/PinLine";
import Styleguide from "@toolkit/Framework/Types/Styleguide";

const markerBase: Toolkit.Theme.GoogleMap.Marker = {
    src: PinFull,
    size: 40,
    color: "primary",
};

const googleMaps: Styleguide["googleMap"] = {
    markerByType: {
        CURRENT_LOCATION: {
            ...markerBase,
            src: PinLine,
        },
        LOCATION: { ...markerBase },
        SELECTED: { ...markerBase },
        WAREHOUSE: { ...markerBase },
    },
    /* Store Custom Code - Start */
    markerByStatus: {
        LIVE: { ...markerBase, color: "primary" },
        SOON: { ...markerBase, color: "secondary.alt" },
        OTHER: { ...markerBase, color: "neutral" },
    },
    /* Store Custom Code - End */
    map: {
        zoom: 14,
        mapContainerStyle: {
            height: "100%",
            width: "100%",
        },
        options: {
            // prettier-ignore
            // To edit styles, copy the array below and paste it in the JSON Import of https://snazzymaps.com/editor
            styles: [
                {
                    "featureType": "all",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "simplified"
                        }
                    ]
                },
                {
                    "featureType": "administrative",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "on"
                        }
                    ]
                },
                {
                    "featureType": "administrative",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#444444"
                        }
                    ]
                },
                {
                    "featureType": "administrative.country",
                    "elementType": "geometry.stroke",
                    "stylers": [
                        {
                            "weight": 1.2
                        }
                    ]
                },
                {
                    "featureType": "administrative.province",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "on"
                        }
                    ]
                },
                {
                    "featureType": "administrative.province",
                    "elementType": "geometry.stroke",
                    "stylers": [
                        {
                            "weight": 1
                        },
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "administrative.neighborhood",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "landscape",
                    "elementType": "all",
                    "stylers": [
                        {
                            "color": "#f2f2f2"
                        }
                    ]
                },
                {
                    "featureType": "poi",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "poi.business",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "poi.park",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "on"
                        },
                        {
                            "gamma": 1.5
                        }
                    ]
                },
                {
                    "featureType": "road",
                    "elementType": "all",
                    "stylers": [
                        {
                            "saturation": -100
                        },
                        {
                            "lightness": 45
                        },
                        {
                            "visibility": "on"
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "simplified"
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "visibility": "simplified"
                        },
                        {
                            "color": "#ffd642"
                        }
                    ]
                },
                {
                    "featureType": "road.arterial",
                    "elementType": "labels.icon",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "transit",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "on"
                        }
                    ]
                },
                {
                    "featureType": "transit.station",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "on"
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "all",
                    "stylers": [
                        {
                            "color": "#b4d2dc"
                        }
                    ]
                }
            ],
        },
    },
};

export default googleMaps;
